


/******* 
 * @description: 针对el-image的图片放大功能 v-magnifyingGlass="imgPath"
 * - 需要一个el-icon放大镜图标，用以标识该图片可以被放大
 * - 当鼠标悬浮在图片上时，动态渲染一个div，用于展示放大的图片
 * @return {*}
 */
import IMG_BaseUrl from "@/filters/index.js";

class Canvas {
    static canvas = null;
    static canvasStyle = null;
    static ctx = null;
    static canvasWidth = 500;//canvas渲染尺寸
    static canvasHeight = 300;
    static visible = false;//是否显示

    constructor() {
        Canvas.canvas = document.createElement('canvas');
        Canvas.ctx = Canvas.canvas.getContext('2d');
        Canvas.initCanvas();
    }
    static initCanvas() {
        this.canvas.width = this.canvasWidth;
        this.canvas.height = this.canvasHeight;
        const canvasStyle = this.canvas.style;
        canvasStyle.position = 'absolute';
        canvasStyle.left = '-' + this.canvasWidth + 'px'
        canvasStyle.top = '0';
        canvasStyle.background = '#65b484';
        canvasStyle.opacity = 0;
        this.canvasStyle = canvasStyle;
    }
    static toggleShow(boolean) {
        this.visible = boolean;
        this.canvasStyle.opacity = boolean ? 1 : 0;
    }
    static setCanvasPosition(left, top) {
        const canvasStyle = this.canvas.style;
        canvasStyle.left = left + 'px';
        canvasStyle.top = top + 'px';
    }
    static append(parentDom) {
        parentDom && parentDom.appendChild(Canvas.canvas);
    }
    static drawImage(imgDom, x, y, modelRectSize) {
        if (!this.visible) return;
        this.clear();
        //ModelRect的width,height
        //画到哪？
        const { width: modelWidth, height: modelHeight } = modelRectSize;
        const { canvasWidth, canvasHeight } = Canvas;
        const { naturalWidth, naturalHeight, width: imgWidth, height: imgHeight } = imgDom;
        const ratioX = imgWidth / naturalWidth;
        const ratioY = imgHeight / naturalHeight;
        const sliceWidth = modelWidth / imgWidth * naturalWidth;//实际的截取尺寸
        const sliceHeight = modelHeight / imgHeight * naturalHeight;
        this.ctx.drawImage(imgDom, x / ratioX, y / ratioY, sliceWidth, sliceHeight, 0, 0, canvasWidth, canvasHeight);
    }
    static clear() {
        this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
    }

}

/******* 
 * @description: 遮罩层
 * @return {*}
 */
class ModelRect {
    dom = null;
    domStyle = null;
    width = 0;
    height = 0;
    widthHalf = 0;//矩形宽度的一半，用于偏移等
    heightHalf = 0;
    x = 0;//矩形坐标
    y = 0;
    _x = 0;//映射到图片像素上的实际坐标
    _y = 0;
    _sliceWidth = 0;//图片上的实际截取像素点宽度
    _sliceHeight = 0;
    maxOffsetX = 0;//矩形中心点最大偏移量
    maxOffsetY = 0;
    imgSizeObj = null;//父元素，图片的尺寸

    constructor() {

    }
    setImgDomSize() { }
    createDom(parentDom) {
        const { offsetWidth, offsetHeight } = parentDom;
        this.width = offsetWidth >> 1;
        this.height = offsetHeight >> 1;
        this.widthHalf = offsetWidth >> 2;
        this.heightHalf = offsetHeight >> 2;
        const dom = document.createElement('div');
        const domStyle = dom.style;
        domStyle.position = 'absolute';
        domStyle.left = '0';
        domStyle.top = '0';
        domStyle.width = this.width + 'px';
        domStyle.height = this.height + 'px';
        domStyle.backgroundColor = 'rgba(0,0,0,0)';
        domStyle.border = '1px solid #ccc';
        domStyle.boxShadow = '0 0 5px #ccc';
        domStyle.cursor = 'move';
        domStyle.opacity = 0;
        this.dom = dom;
        this.domStyle = domStyle;
        parentDom.appendChild(this.dom);
        return this.dom.style;
    }
    canMove(x, y) {
        //根据鼠标移动的坐标点，判断是否在矩形范围内
        let resume = true;
        if (
            x < 0 || y < 0
        ) {
            resume = false;
        } else if (this.imgSizeObj) {
            if (x > this.imgSizeObj.width - this.width || y > this.imgSizeObj.height - this.height) {
                resume = false;
            }
        }
        return resume;
    }
    toggleShow(boolean = false) {
        // console.log('toggleShow', boolean);
        if (boolean) {
            this.domStyle.transition = 'none';
            this.domStyle.backgroundColor = "rgba(0,0,0,0.3)";
            this.domStyle.opacity = 1;
        } else {
            this.domStyle.transition = '.2s ease-in';
            this.domStyle.transform = `translate(30%,30%)`;
            this.domStyle.backgroundColor = 'rgba(0,0,0,0)';
            this.domStyle.opacity = 0;
        }
    }
    get size() {
        // console.log("访问了size", this)
        return {
            width: this.width,
            height: this.height,
            widthHalf: this.widthHalf,
            heightHalf: this.heightHalf,
        }
    }

}

/******* 
 * @description: 观察activeDom是否与watchAreaDom有交叉
 * @return {*}
 */
class WatchIntersect {
    static watchAreaDom = null;//观察区域的Dom
    static activeDom = null;//活动dom

    constructor() {

    }


}

/******* 
 * @description: 被挂载的目标dom元素，父元素
 * @return {*}
 */
class ImgParent {
    width = 0;
    height = 0;
    constructor(dom) {
        this.dom = dom;
    }
    //鼠标在图片上方移动，会产生一个截取范围
    init() {
        this.setMagnifyTag(this.dom);
        this.setHoverEvent();
    }
    setHoverEvent() {
        const imgParentDom = this.dom;
        const modelRect = new ModelRect();
        const modelRectDomStyle = modelRect.createDom(imgParentDom);
        let { width, height, widthHalf, heightHalf } = modelRect.size;
        modelRect.imgSizeObj = {
            width,
            height,
        }
        const { offsetWidth, offsetHeight } = imgParentDom;
        this.width = offsetWidth;
        this.height = offsetHeight;
        // debugger;
        new Canvas();
        Canvas.initCanvas();
        Canvas.append(document.querySelector('[tag="realNameDialog"] .el-dialog'));
        imgParentDom.onmouseover = () => {
            if (imgParentDom.querySelector('img')) {
                modelRect.toggleShow(true);
                Canvas.toggleShow(true);
            }
            // console.log('imgDom 参数', this.imgDom.naturalWidth, this.imgDom.naturalHeight);


            imgParentDom.onmousemove = function (e) {
                e.preventDefault();
                const { layerX, layerY } = e;
                const x = layerX - widthHalf;
                const y = layerY - heightHalf;
                // console.log(x, y);
                //什么条件下不能移动
                // if (false === ModelRect.canMove(x, y)) return;

                if (x <= 15) {
                    modelRectDomStyle.transform = `translate(0px,${y}px)`;
                } else if (x >= offsetWidth - width - 15) {
                    modelRectDomStyle.transform = `translate(${offsetWidth - width}px,${y}px)`;
                } else if (y <= 15) {
                    modelRectDomStyle.transform = `translate(${x}px,0px)`;
                } else if (y >= offsetHeight - heightHalf * 2 - 15) {
                    modelRectDomStyle.transform = `translate(${x}px,${offsetHeight - height}px)`;
                } else {
                    modelRectDomStyle.transform = `translate(${x}px,${y}px)`;
                }

                Canvas.drawImage(imgParentDom.querySelector('img'), x, y, modelRect.size);

            }

        }
        imgParentDom.onmouseout = () => {
            modelRect.toggleShow(false);
            Canvas.toggleShow(false);
        };
    }
    //设置放大镜标志
    setMagnifyTag(imgParentDom) {
        if (!imgParentDom || (imgParentDom && imgParentDom.tagName !== 'DIV')) return;
        imgParentDom.style = {
            position: 'relative',
        }
        // 设置放大镜
        const magnifyingGlassDom = document.createElement('div');
        const magnifyingGlassDomStyle = magnifyingGlassDom.style;
        magnifyingGlassDom.innerHTML = "🔍";
        magnifyingGlassDomStyle.position = 'absolute';
        magnifyingGlassDomStyle.right = '0';
        magnifyingGlassDomStyle.top = '0';
        magnifyingGlassDomStyle.width = '25px';
        magnifyingGlassDomStyle.height = '25px';
        magnifyingGlassDomStyle.lineHeight = '25px';
        magnifyingGlassDomStyle.textAlign = 'center';
        magnifyingGlassDomStyle.border = '1px solid #ccc';
        magnifyingGlassDomStyle.borderRadius = '50%';
        magnifyingGlassDomStyle.backgroundColor = '#fff';
        magnifyingGlassDomStyle.boxShadow = '0 0 5px #ccc';
        magnifyingGlassDomStyle.cursor = 'zoom-in';
        imgParentDom.appendChild(magnifyingGlassDom);
    }
    get size() {
        return {
            width: this.width,
            height: this.height
        }
    }
}

export default {
    inserted(el, binding, vnode) {
        console.log("el", el)
        if (!binding.value) return;
        const imgParentIns = new ImgParent(el);
        imgParentIns.init();

        // const path = IMG_BaseUrl + binding.value;
        // console.log('v-magnifyingGlass', el, binding, IMG_BaseUrl, el.tagName);

    }
}


// WEBPACK FOOTER //
// ./src/directives/magnifyingGlass.js